module.exports = __webpack_public_path__ + "img/flower-big.a80b48cd.svg";